import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Czy wszystko jest naprawdę w PDF?',
  answer: 'Tak. Wszystkie 6 tomów i 6 bonusów to pliki PDF gotowe do pobrania od razu po zakupie. Możesz je drukować lub przeglądać na tablecie, laptopie lub telefonie.'
}, {
  question: 'Czy to jest odpowiednie dla mojego typu trenowania?',
  answer: 'Tak. System obejmuje wszystkie grupy wiekowe od U6 do U13 i wszystkie sytuacje treningowe — od podstaw po zaawansowaną taktykę, od treningu indywidualnego po grę zespołową.'
}, {
  question: 'Czy potrzebuję specjalnej wiedzy żeby to używać?',
  answer: 'Nie. System jest zaprojektowany tak żeby każdy trener mógł go używać od pierwszego dnia. Otwierasz PDF i zaczynasz trenować.'
}, {
  question: 'Kiedy otrzymam materiały?',
  answer: 'Natychmiast po zakupie. Otrzymasz link do pobrania na swój adres email w ciągu kilku minut.'
}, {
  question: 'Co jeśli nie jestem zadowolony?',
  answer: 'Masz 7 dni gwarancji zwrotu pieniędzy bez żadnych pytań. Jeśli system nie spełni Twoich oczekiwań — zwracamy całą kwotę.'
}, {
  question: 'Dlaczego cena jest tak niska?',
  answer: 'Chcemy żeby każdy polski trener miał dostęp do profesjonalnego systemu niezależnie od budżetu. To jest nasza misja.'
}];
export function FAQ() {
  // First question open by default as preview
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream-bg py-12 md:py-20 px-4 md:px-6" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-center text-navy-primary mb-8 md:mb-12" data-id="element-94">
          Najczęściej zadawane pytania
        </motion.h2>

        <div className="space-y-3 md:space-y-4" data-id="element-95">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-96">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-gray-50 transition-colors" aria-expanded={openIndex === index} data-id="element-97">
                <span className="font-bold text-navy-primary text-base md:text-lg pr-4" data-id="element-98">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="flex-shrink-0" data-id="element-99">
                  <ChevronDown className="w-5 h-5 md:w-6 md:h-6 text-gold-accent" data-id="element-100" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-101">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-102">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-gray-700 leading-relaxed" data-id="element-103">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}